import { render, staticRenderFns } from "./RentabilityChart.vue?vue&type=template&id=b50932e4&scoped=true"
import script from "./RentabilityChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./RentabilityChart.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RentabilityChart.vue?vue&type=style&index=0&id=b50932e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50932e4",
  null
  
)

export default component.exports